const en = {
  nav: {
    why: 'WHY',
    when: 'WHEN',
    what: 'WHAT',
    situation: 'SITUATION',
    video: 'VIDEO',
    social: 'SOCIAL',
    about: 'ABOUT',
    contact: 'CONTACT',
    menu: 'MENU',
    close: 'CLOSE',
  },
  hero: {
    meta: 'ALBERTO SCOTTA — THE CREATIVE ENGINEER',
    scroll: 'SCROLL',
  },
  payoff: {
    lines: ['THERE’S', 'ALWAYS', 'A SOLUTION.'],
  },
  verbs: [
    { id: 'raccontare', word: 'RACCONTARE.', def: 'Stories of people, events, memories.' },
    { id: 'emozionare', word: 'EMOZIONARE.', def: 'Anecdotes · Memories · Experiences' },
    { id: 'convincere', word: 'CONVINCERE.', def: 'Arguments, framing, persuasion.' },
  ],
  marquee: ['RACCONTARE', 'EMOZIONARE', 'CONVINCERE', 'RISOLVERE', "THERE'S ALWAYS A SOLUTION."],
  why: {
    kicker: 'WHY',
    lines: ['YOU HAVE', 'AN OPPORTUNITY.'],
    extra: ['ARE YOU READY', 'TO SEIZE IT?'],
    body: 'We communicate all the time, even when we don’t realise it. A word, a silence, a well-asked question can change a relationship, a negotiation or an opportunity. Communication isn’t just about explaining yourself: it’s about understanding, moving and convincing.',
    goal: ['The goal?', 'To communicate better', ['than ', '87.44%', ' of people.']],
    note: 'The number is debatable. The advantage, much less so.',
  },
  bridge: {
    kicker: 'WHERE IT STARTS',
    a: 'LIFE DOESN’T PRESENT SUBJECTS.',
    b: 'IT PRESENTS SITUATIONS.',
    quote: 'We don’t think “now I need a negotiation technique”. We think: “I have to convince this person”.',
  },
  situations: {
    kicker: 'WHEN',
    title: 'WHICH SITUATION ARE YOU IN?',
    sub: 'FIRST THE SITUATION. THEN THE TOOLS.',
    hint: 'SCROLL',
    scenes: [
      {
        n: '01',
        lines: ['YOU HAVE', 'TO TAKE', 'THE STAGE.'],
        tags: ['Public speaking', 'Presentations', 'Storytelling'],
        size: 'big',
      },
      {
        n: '02',
        lines: ['YOU HAVE', 'TO CONVINCE', 'SOMEONE.'],
        tags: ['Negotiation', 'Communication', 'Persuasion'],
        size: 'big',
      },
      {
        n: '03',
        lines: ['YOU HAVE', 'SOMETHING', 'TO SAY.'],
        extra: ["YOU DON'T KNOW", 'HOW TO SAY IT.'],
        tags: ['Communication', 'Storytelling'],
        size: 'big',
      },
      {
        n: '04',
        lines: ['PEOPLE', 'DON’T REACT', 'THE WAY YOU EXPECTED.'],
        tags: ['Emotional intelligence', 'Relationships', 'Communication'],
        size: 'small',
      },
      {
        n: '05',
        lines: ['SOMETHING', 'WENT', 'WRONG.'],
        tags: ['Problem solving', 'Negotiation', 'Situation'],
        size: 'big',
      },
    ],
  },
  invasion: {
    line: 'FIRST THE SITUATIONS. THEN THE TOOLS.',
  },
  whatwedo: {
    kicker: 'WHAT',
    title: 'WHAT WE CAN DO TOGETHER',
    rows: [
      {
        id: 'docenze',
        index: '01',
        label: 'TEACHING',
        body: 'For schools, academies, universities, training institutions and organisations. Not just traditional lectures, but what works best:',
        chips: ['interaction', 'role playing', 'stories', 'experiments', 'questions', 'games', 'real situations'],
      },
      {
        id: 'consulenze',
        index: '02',
        label: 'COACHING & CONSULTING',
        body: 'Tailor-made paths, built around:',
        chips: ['a goal', 'a problem', 'a situation', 'a presentation', 'a negotiation', 'a decision', 'an important communication'],
      },
      {
        id: 'corsi',
        index: '03',
        label: 'COURSES',
        body: '',
        items: ['Communication', 'Negotiation', 'Emotional intelligence', 'Public Speaking', 'Storytelling', 'Problem Solving'],
      },
    ],
  },
  situation: {
    kicker: 'SITUATION',
    title: 'SITUATION',
    subtitle: 'THE ROLE-PLAYING GAME OF REAL LIFE',
    headlineA: 'HERE, SITUATIONS',
    headlineB: 'AREN’T EXPLAINED.',
    headlineC: 'THEY’RE LIVED.',
    intro: 'A hands-on experience to live together. Some people take part. Others watch. Then we reconstruct what happened.',
    gives: ['A ROLE.', 'A CONTEXT.', 'A GOAL.', 'INFORMATION THE OTHERS DON’T HAVE.'],
    noScript: 'NO SCRIPT. Everyone reacts the way they would in real life.',
    cta: 'TRY A SITUATION',
    scene: {
      role: 'You are one of the guests.',
      context: 'A dinner, six people. Someone confidently states something wrong about you. Everyone turns towards you.',
      goal: 'Come out of it well. No drama, no scenes.',
      prompt: 'WHAT DO YOU DO?',
      options: [
        { key: 'A', text: 'Change the subject and pretend nothing happened.' },
        { key: 'B', text: 'Answer sharply. Full stop.' },
        { key: 'C', text: 'Take the line, flip it, tell the true version.' },
      ],
    },
    result: {
      chosenLabel: 'YOU PICKED',
      noRight: 'THERE IS NO RIGHT ANSWER',
      q1: 'WHAT DID YOU WANT TO GET?',
      q2: 'WHAT DID YOU ACTUALLY GET?',
      body: 'We don’t always look for the “right” answer. We discover which consequences different choices produce. It’s a safe environment where you can:',
      can: ['FAIL.', 'TRY.', 'CHANGE.', 'TRY AGAIN.'],
      retry: 'BACK',
    },
    areasLabel: 'REAL-LIFE SITUATIONS, CHOSEN FROM:',
    areas: ['WORK', 'COUPLES', 'FRIENDS', 'SOCIAL', 'NEGOTIATIONS', 'CONFLICTS', 'MONEY', 'THE UNEXPECTED', 'LEGAL MATTERS'],
    closeA: 'BECAUSE IN REAL LIFE, BEING RIGHT ISN’T THE POINT.',
    closeB: 'WHAT COUNTS IS READING THE SITUATION AND KNOWING HOW TO REACH YOUR GOALS.',
  },
  stories: {
    kicker: 'VIDEO',
    headline: ['ANYTHING', 'CAN BECOME', 'A STORY.'],
    body: 'On my channel I tell stories, like the ones that start from a football shirt and lead to a person, a place, an event. I analyse how public figures communicate, create practical guides and share useful tips to communicate better, every day.',
    topics: ['Stories', 'Communication analysis', 'Guides', 'Useful tips'],
    watch: 'WATCH THE CHANNEL',
  },
  words: {
    kicker: '05 — COMMUNICATION ANALYSIS',
    ghost: 'WORDS MATTER.',
    headline: ['WORDS ARE NEVER', 'JUST WORDS.'],
    body: 'I analyse interviews, press conferences, speeches, statements, media communication. The goal is not to judge the person: it’s to use real cases to understand better.',
    items: ['words', 'arguments', 'framing', 'persuasion', 'communication mistakes', 'fallacies', 'body language when observable'],
  },
  about: {
    kicker: 'ABOUT',
    lead: 'The engineer who chose to be a creative.',
    steps: [
      { id: 'ingegnere', word: 'ENGINEER.', d: 'Politecnico di Torino. Telecommunications engineering.' },
      { id: 'creativo', word: 'CREATIVE.', d: 'Deltatre: Head of UXD, then Creative Director.' },
      { id: 'comunicatore', word: 'COMMUNICATOR.', d: '20+ years presenting ideas, concepts and products.' },
      { id: 'storyteller', word: 'STORYTELLER.', d: 'People, events, places, objects: everything has a story.' },
      { id: 'docente', word: 'TEACHER.', d: 'Real situations, role playing, games, questions.' },
      { id: 'creator', word: 'CREATOR.', d: 'Head of Football Manager ITA since 1997. Content reaching millions of fans.' },
      { id: 'panoz', word: 'PANOZ.', d: 'Alberto Scotta.' },
    ],
  },
  rooms: {
    kicker: 'EXPERIENCE',
    headline: ["I'VE BEEN", 'IN SOME', 'INTERESTING ROOMS.'],
    realities: ['UEFA', 'FIFA', 'IOC', 'FIFA Museum', 'THE FA', 'Football Manager', 'Now United', 'Accademia dello Sport', 'Sportitalia'],
    note: 'Activities, presentations and projects.',
    seenOn: 'SEEN ON',
  },
  contact: {
    kicker: 'CONTACT',
    lineA: 'LET’S FIND',
    lineB: 'A SOLUTION.',
    sub: 'TROVIAMO UNA SOLUZIONE.',
    cta: 'MESSAGE ME ON TELEGRAM',
    mail: 'SEND ME AN EMAIL',
  },
  social: { kicker: 'SOCIAL' },
  footer: { rights: 'Alberto Scotta — PANOZ4U' },
};

export default en;
